import { ReactNode } from "react";
import SelectInput, { OptionType } from "../Inputs/SelectInput";

const DEFAULT_PAGE_SIZE_OPTIONS: OptionType[] = [
  { label: "10", value: "10" },
  { label: "20", value: "20" },
  { label: "50", value: "50" },
];

type ListViewControlsProps = {
  pageSize: number;
  onPageSizeChange: (pageSize: number) => void;
  pageSizeOptions?: OptionType[];
  children?: ReactNode;
};

export const ListViewControls = (props: ListViewControlsProps) => {
  const {
    pageSize,
    onPageSizeChange,
    pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
    children,
  } = props;

  return (
    <div className="flex items-end justify-between">
      <div className="w-32">
        <label className="block font-medium mr-2">Ver</label>
        <SelectInput
          options={pageSizeOptions}
          value={pageSize}
          onChange={(e) => onPageSizeChange(parseInt(e.target.value, 10))}
        />
      </div>
      {children && <div className="flex gap-2 mb-2">{children}</div>}
    </div>
  );
};
